  <!-- HEADER -->
  <div class="header mat-accent-bg p-20 customHeaderScrumbread" fxLayout="row" fxLayoutAlign="start center">
      <div fxLayout="column" fxLayoutAlign="center start">
          <div class="white-fg" fxLayout="row" fxLayoutAlign="start center">
              <!-- <mat-icon class="s-16">{{parentIcon}}</mat-icon>
              <mat-icon class="s-16">chevron_right</mat-icon> -->
              <span>{{pageName}}</span>
          </div>
      </div>
  </div>
  <!-- / HEADER -->


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/scrum-bread-bar/scrum-bread-bar.component.html